import axios from "axios";
import { useAuth } from "@clerk/react";
import { useCallback } from "react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const errMsg = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg?.replace("Value error, ", "")).join(". ");
  return d || fallback;
};

export function useAdminApi() {
  const { getToken } = useAuth();
  return useCallback(
    async (config) => {
      const token = await getToken();
      const res = await api.request({ ...config, headers: { ...(config.headers || {}), Authorization: `Bearer ${token}` } });
      return res.data;
    },
    [getToken],
  );
}
